import { AnimatePresence, motion, useMotionValue } from 'motion/react';
import React, { useEffect, useState } from 'react';
import { SiteTransitions } from '../../../utils/transitions';
import useDebounce from '../../../utils/hooks/useDebounce';
import { useNavigate } from 'react-router';

const WeirdText: React.FC<{children: any}> = ({ children }) => {
    const rotateY = useMotionValue('0deg');

    return (
        <motion.div
            className='w-96 text-center text-wrap'
            animate={{ scale: 1.2, transition: { duration: 2, ease: 'easeOut' } }}
            exit={{ rotateY: '180deg', opacity: 0, transition: { duration: .1 } }}
            style={{ rotateY, filter: 'drop-shadow(0 0 8px #ffffff)' }}
        >
            {children}
        </motion.div>
    )
}

const WeirdRoute: React.FC = () => {
    const [cursor, setCursor] = useState(0);
    const headers = [
        <div 
            className='text-teko text-2xl sm:text-4xl text-red-700 italic px-4 py-2 text-nowrap'
            style={{ filter: 'drop-shadow(0px 0px 6px rgba(0, 0, 0, .4))' }}
        >
            Oops... looks like things took a weird route!
        </div>,
        <div 
            className='text-teko text-2xl sm:text-4xl text-red-700 italic px-4 py-2 text-nowrap'
            style={{ filter: 'drop-shadow(0px 0px 6px rgba(0, 0, 0, .4))' }}
        >
            Taking you back...
        </div>
    ]

    useDebounce(() => {
        setCursor(cursor + 1);
    }, 2000, [cursor])

    const navigate = useNavigate();

    const goBack = () => { navigate(-1) };

    useEffect(() => {
        if (cursor > 0) {
            setTimeout(goBack, 1000);
        }
    }, [cursor])

    return (
        <motion.div
            layout
            variants={SiteTransitions}
            initial='initial'
            animate='animate'
            exit='exit'
            className='size-full flex justify-center items-center'
            style={{ backgroundImage: 'url("/thg/bg/bg_landing.png")' }}
        >
            <AnimatePresence mode='wait'>
                <WeirdText
                    key={cursor}
                >
                    {headers[cursor]}
                </WeirdText>
            </AnimatePresence>
            
        </motion.div>
    )
}

export default WeirdRoute;